import type React from "react";

import { ImageThumbnail } from "./ImageThumbnail";

interface InlineUploaderReadOnlyProps {
  value: string | null;
}

export const InlineUploaderReadOnly: React.FC<InlineUploaderReadOnlyProps> = ({
  value,
  ...props
}) => {
  if (!value) {
    return null;
  }

  return (
    <div className="inline-uploader-readonly d-flex w-100 h-100">
      <ImageThumbnail
        previewUrl={value}
        altText="existing image"
        disabled={false}
        showDeleteButton={false}
      />
    </div>
  );
};
